<template>
  <div class="container mt-4 card p-4 shadow-sm">
    <h3 class="text-center mb-4">Reporte de Limpieza Diaria</h3>

    <div class="row mb-4 align-items-end">
      <div class="col-md-6">
        <label class="form-label">Número de camareras</label>
        <input
          type="number"
          v-model.number="cantidadCamareras"
          class="form-control"
          min="1"
          placeholder="Ingrese cantidad de camareras"
        />
      </div>
      <div class="col-md-6 text-end">
        <button class="btn btn-primary mt-3" @click="generarReporte">
          🔄 Generar Reporte
        </button>
      </div>
    </div>

    <div v-if="reporte.length">
      <div
        v-for="(camarera, index) in reporte"
        :key="index"
        class="card my-3 shadow-sm"
      >
        <div class="card-header bg-light d-flex justify-content-between align-items-center">
          <strong>{{ camarera.recamarera }}</strong>
          <button
            class="btn btn-sm btn-outline-dark"
            @click="imprimir(camarera)"
          >
            🖨️ Imprimir
          </button>
        </div>
        <div class="card-body p-3">
          <ul class="list-group">
            <li
              v-for="habitacion in camarera.habitaciones"
              :key="habitacion.IdHabitacion"
              class="list-group-item"
            >
              <strong>Habitación #{{ habitacion.Numero }}</strong> - {{ habitacion.tipo.NombreTipo }}<br />
              Personas: {{ habitacion.TotalPersonas }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div v-else class="alert alert-info mt-4">
      No hay datos para mostrar. Asegúrese de ingresar la cantidad de camareras.
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '@/config/config';

export default {
  name: 'ReporteLavanderiaDiaria',
  data() {
    return {
      cantidadCamareras: 1,
      reporte: []
    };
  },
  methods: {
    async generarReporte() {
      if (!this.cantidadCamareras || this.cantidadCamareras < 1) {
        this.$emit('error', 'Ingrese una cantidad válida de camareras.');
        return;
      }

      try {
        const res = await axios.get(`${API_URL}/reporte-limpieza`, {
          params: { camareras: this.cantidadCamareras }
        });
        this.reporte = res.data.reporte;
      } catch (error) {
        console.error('Error al generar reporte:', error);
        this.$emit('error', 'Hubo un error al obtener el reporte');
      }
    },

    imprimir(camarera) {
  const html = `
    <html>
      <head>
        <style>
          body {
            font-family: monospace;
            font-size: 11px;
            padding: 5px;
            width: 220px;
          }
          .line {
            margin-bottom: 4px;
            border-bottom: 1px dashed #000;
            padding-bottom: 2px;
          }
          .center {
            text-align: center;
            font-weight: bold;
            margin-bottom: 8px;
          }
        </style>
      </head>
      <body>
        <div class="center">Limpieza - ${camarera.recamarera}</div>
        ${camarera.habitaciones
          .map(
            (h) =>
              `<div class="line">
                #${h.Numero} - ${h.tipo.NombreTipo} - ${h.TotalPersonas} Persona(s)
              </div>`
          )
          .join('')}
      </body>
    </html>`;

  const ventana = window.open('', '_blank', 'width=250,height=600');
  ventana.document.write(html);
  ventana.document.close();
  ventana.onload = () => {
    ventana.print();
    ventana.close();
  };
}

  }
};
</script>
